<script lang="ts" setup>
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import router from "@/router/index";

onMounted(async () => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  try {
    await authStore.signinRedirectCallback();
    const authorized = await authStore.isAllowedForApplication();
    if (authorized) {
      await userStore.setUserAccessData();
      await router.replace({ name: "Dashboard", params: { partyReference: userStore.currentPartyReference } });
    } else {
      await router.replace({ name: "Unauthorized" });
    }
  } catch {
    await router.replace({ name: "Unauthorized" });
  }
});
</script>

<template>
  <v-container class="h-100 callback">
    <v-row class="h-100" align="center" justify="center">
      <v-col cols="auto"> Aanmelding voltooien... </v-col>
    </v-row>
  </v-container>
</template>
